import {
	ReportAggregates,
	Reports,
	TollfreeEnhancedDetailIndexResponse
} from 'RtModels';
import {
	IRtVueContainerState,
	RtVueReportContainer
} from 'RtUi/app/rtVue/common/lib/containers/RtVueReportContainer';
import { RtVueHttp } from 'RtUi/app/rtVue/common/lib/http/RtVueHttp';
import { TfEnhancedDetailsReportGrid } from 'RtUi/app/rtVue/TfEnhancedDetailsReport/lib/grids/TfEnhancedDetailsReportGrid';
import { TfEnhancedDetailsReportRouter } from 'RtUi/app/rtVue/TfEnhancedDetailsReport/TfEnhancedDetailsReport.router';
import { IApplicationContainerProps } from 'RtUi/components/containers/ApplicationContainer';
import { ArrayResource } from 'RtUi/utils/http/resources/ArrayResource';
import { HttpResource } from 'RtUi/utils/http/resources/HttpResource';

@TfEnhancedDetailsReportRouter.getIndexRtUiController({
	groupName: 'Toll-Free Enhanced Details',
	groupId: 'VueTollFreeEnhancedDetails',
	isHidden: true
})
export class TfEnhancedDetailsReportIndexContainer extends RtVueReportContainer<TollfreeEnhancedDetailIndexResponse> {
	public state: IRtVueContainerState<TollfreeEnhancedDetailIndexResponse>;

	protected reportId = Reports.TollfreeEnhancedDetail;
	protected router = TfEnhancedDetailsReportRouter;

	constructor(props: IApplicationContainerProps) {
		super(props);

		const baseState = this.getBaseState();
		let timeRange = this.getTimeRangeFromLocalStorage(Reports.TollfreeEnhanced);

		if (!timeRange) {
			timeRange = this.getTimeRangeFromLocalStorage();
		}

		if (!timeRange) {
			timeRange = baseState.timeRange;
		}

		this.state = {
			...baseState,
			timeRange,
			dataSums: [ReportAggregates.Margin]
		};
	}

	protected async getResource(): Promise<
		HttpResource<TollfreeEnhancedDetailIndexResponse>
	> {
		const {
			timeRange,
			filters,
			partition,
			preset,
			dataSums,
			additionalColumns,
			havingFilter
		} = this.state;

		const vueHttp = new RtVueHttp();
		const { data, totalCount } = await vueHttp.getTfEnhancedDetailsView(
			timeRange,
			filters,
			preset,
			dataSums,
			partition,
			additionalColumns?.map((column) => column.value),
			havingFilter
		);
		const resource = new ArrayResource<TollfreeEnhancedDetailIndexResponse>(
			'vuid',
			data
		);
		resource.setTotalCount(totalCount);

		return resource;
	}

	protected renderReports(): React.ReactNode {
		return (
			<>
				<TfEnhancedDetailsReportGrid
					isLoading={this.state.loadingReport}
					defaultSorting={this.state.defaultSorting}
					onSortingChange={this.onSortedChange}
					resource={this.state.resource}
				/>
			</>
		);
	}
}
